/* LIBRAIRIRES */ 
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/* COMPONENT */
import CustomAlert from '../CustomAlert/CustomAlert';

/* FIREBASE */
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, firestore } from '../../firebase';
import { collection, doc, setDoc } from 'firebase/firestore';

/* MUI */
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';

/* ICONS */
import { FaEnvelope, FaLock, FaUser } from 'react-icons/fa';

/* LOADER */
import { Oval } from 'react-loader-spinner';

/* CSS */
import './NewUser.css';

const NewUser = ({toggleLogin}) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const navigate = useNavigate();

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&.]*$/;
        return passwordRegex.test(password);
      };

    const handleSignUp = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (email === '' || password === '') {
            setIsLoading(false);
            return console.log('Veuillez saisir un email/password');
          }
          
          if (confirmPassword !== password) {
            setIsLoading(false);
            setAlertSeverity("warning");
            setAlertMessage('Les mots de passe ne correspondent pas');
            setOpenAlert(true);
            console.log('Les mots de passe ne correspondent pas');
            return 
          }
        
          if (!validatePassword(password)) {
            setIsLoading(false);
            setAlertSeverity("warning");
            setAlertMessage('Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un chiffre.');
            setOpenAlert(true);
            return;
          }

        if (email == '' || password == '') { return console.log('Veuillez saisir un email/password')}
        if (confirmPassword === password) {
            createUserWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    const user = userCredential.user;
                    const userData = {
                        userId: user.uid,
                        email: user.email,
                        name: nom,
                        firstName: prenom,
                        role: "utilisateur",
                        createdAt: new Date()
                    };
    
                    const usersRef = collection(firestore, 'users');
                    setDoc(doc(usersRef, user.uid), userData)
                        .then(() => {
                            console.log("User document created successfully!");
                            setAlertSeverity("success");
                            setAlertMessage("Utilisateur crée avec succés !");
                            setOpenAlert(true);
                            navigate('/Dashboard');
                        })
                        .catch((error) => {
                            console.error("Error adding user document: ", error);
                            setAlertSeverity("error");
                            setAlertMessage(`Erreur lors de la création d'un utilisateur. ${error} Veuillez réessayer.`);
                            setOpenAlert(true);
                        })
                        .finally(() => {
                            setIsLoading(false);
                        })
                })
                .catch((error) => { 
                    console.log(error);
                    setAlertSeverity("error");
                    setAlertMessage(`Erreur lors de la création d'un utilisateur. ${error} Veuillez réessayer.`);
                    setOpenAlert(true);
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }

    return (
        <div className='container-new-user'>
            <div className='content-new-user'>
                <form className="container-form" onSubmit={handleSignUp}>
                    <p>Nouvel inscription</p>
                    <div className="input-container">
                        <FaEnvelope className="input-icon" />
                        <TextField id="filled-basic" type='email' label="Email" variant="filled" value={email} onChange={(e) => setEmail(e.target.value)}/>
{/*                         <input type='email' className='inputLogin' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Adresse Email' required />
 */}                    </div>
                    <div className="input-container">
                        <FaUser className="input-icon" />
                        <TextField id="filled-basic" type='text' label="Nom" variant="filled" value={nom} onChange={(e) => setNom(e.target.value)}/>
                        {/* <input type='text' className='inputLogin' value={nom} onChange={(e) => setNom(e.target.value)} placeholder='Nom' /> */}
                    </div>
                    <div className="input-container">
                        <FaUser className="input-icon" />
                        <TextField id="filled-basic" type='text' label="Prénom" variant="filled" value={prenom} onChange={(e) => setPrenom(e.target.value)}/>
{/*                         <input type='text' className='inputLogin' value={prenom} onChange={(e) => setPrenom(e.target.value)} placeholder='Prénom' />
 */}                    </div>
                    <div className="input-container">
                        <FaLock className="input-icon" />
                        <TextField id="filled-basic" type='password' label="Mot de passe" variant="filled" value={password} onChange={(e) => setPassword(e.target.value)}/>
{/*                         <input type='password' className='inputLogin' value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Mot de passe' required />
 */}                    </div>
                    <div className="input-container">
                        <FaLock className="input-icon" />
                        <TextField id="filled-basic" type='password' label="Confirmer MDP" variant="filled" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>

{/*                         <input type='password' className='inputLogin' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder='Confirmer Mot de passe' required />
 */}                    </div>
                    <div className='container-btns'>
                        <Button variant="contained" onClick={handleSignUp}>
                        {
                            isLoading ?
                            <Oval
                                height={25}
                                width={25}
                                color="white"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#4fa94d"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                                />
                            :
                            'Inscription'
                        }
                        </Button>
                    </div>
                </form>
                <CustomAlert 
                    open={openAlert}
                    onClose={handleCloseAlert}
                    message={alertMessage}
                    severity={alertSeverity}
                />
            </div>
        </div>
    );
}

export default NewUser;